import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, Observable, ObservableInput } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { MMDReads } from '../../models/mmd-read';
import { MarketDrawerRootReducerState } from '../reducer';
import { MMDService } from '../../services/mmd.service';
import {
  MMD_LOAD_REQUESTED,
  MMDLoadSuccessAction,
  MMDLoadErrorAction
} from './actions';

@Injectable()
export class MMDReadsEffects {
  @Effect()
  public loadMMDReads$: Observable<
    MMDLoadSuccessAction | MMDLoadErrorAction
  > = this.actions.pipe(
    ofType(MMD_LOAD_REQUESTED),
    withLatestFrom(this.store),
    mergeMap(
      ([action, state]): ObservableInput<MMDReads> =>
        this.mmdService.fetchData(state.marketDrawer.dealDate)
    ),
    map((mmdReads: MMDReads) => new MMDLoadSuccessAction(mmdReads)),
    catchError((error: Error) => of(new MMDLoadErrorAction(error.message)))
  );

  constructor(
    private store: Store<MarketDrawerRootReducerState>,
    private actions: Actions,
    public mmdService: MMDService
  ) {}
}
